import React, {useEffect} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useApplicationContext} from "../application/ApplicationContext";
import {activeUser} from "../services/AuthService";
import {ProtectedElement} from "../auth/ProtectedElement";
import {RoleType} from "../models/Role";
import {DashboardPage} from "../pages/DashboardPage/DashboardPage";
import {PartnersPage} from "../pages/PartnersPage/PartnersPage";
import {WarehousesPage} from "../pages/WarehousesPage/WarehousesPage";
import {InitialWarehouseStatePage} from "../pages/InitialWarehouseStatePage/InitialWarehouseStatePage";
import {InitialWarehouseRepromaterialStatePage} from "../pages/InitialWarehouseRepromaterialStatePage/InitialWarehouseRepromaterialStatePage";
import {WarehousesOverviewPage} from "../pages/WarehousesOverviewPage/WarehousesOverviewPage";
import {UsersPage} from "../pages/UsersPage/UsersPage";
import {NewMercantileRequestsPage} from "../pages/NewMercantileRequestsPage/NewMercantileRequestsPage";
import {NewDocumentOfReceivePage} from "../pages/NewDocumentOfReceivePage/NewDocumentOfReceivePage";
import {NewDocumentOfReceivePreviewPage} from "../pages/NewDocumentOfReceivePage/NewDocumentOfReceivePrevievPage";
import {NewDocumentOfOutputPage} from "../pages/NewDocumentOfOutputPage/NewDocumentOfOutputPage";
import {NewDocumentOfOutputPreviewPage} from "../pages/NewDocumentOfOutputPage/NewDocumentOfOutputPreviewPage";
import {NewDocumentOfReceiveRepromaterialPage} from "../pages/NewDocumentOfReceiveRepromaterialPage/NewDocumentOfReceiveRepromaterialPage";
import {NewDocumentOfReceiveRepromaterialPreviewPage} from "../pages/NewDocumentOfReceiveRepromaterialPage/NewDocumentOfReceiveRepromaterialPreviewPage";
import {NewDocumentOfOutputRepromaterialPage} from "../pages/NewDocumentOfOutputRepromaterialPage/NewDocumentOfOutputRepromaterialPage";
import {NewDocumentOfOutputRepromaterialPreviewPage} from "../pages/NewDocumentOfOutputRepromaterialPage/NewDocumentOfOutputRepromaterialPreviewPage";
import {ProductsPage} from "../pages/ProductsPage/ProductsPage";
import {NewReproRequestsPage} from "../pages/NewReproRequestsPage/NewReproRequestsPage";
import {NewMercantileRequestDetailsPage} from "../pages/NewMercantileRequestDetailsPage/NewMercantileRequestDetailsPage";
import {NewReproRequestDetailsPage} from "../pages/NewReproRequestDetailsPage/NewReproRequestDetailsPage";
import {LoginPage} from "../pages/LoginPage/LoginPage";
import {SettingsPage} from "../pages/SettingsPage/SettingsPage";
import {ProductReservationPage} from "../pages/ProductReservationPage/ProductReservationPage";
import {ProductReproReservationPage} from "../pages/ProductReproReservationPage/ProductReproReservationPage";
import {ProductOverviewPage} from "../pages/ProductOverviewPage/ProductOverviewPage";
import {NewRepromaterialInputPage} from "../pages/NewRepromaterialInputPage/NewRepromaterialInputPage";
import {NewMercantileInputPage} from "../pages/NewMercantileInputPage/NewMercantileInputPage";
import {NewRepromaterialOutputPage} from "../pages/NewRepromaterialOutputPage/NewRepromaterialOutputPage";
import {NewMercantileOutputPage} from "../pages/NewMercantileOutputPage/NewMercantileOutputPage";
import {DailyReportPage} from "../pages/DailyReportPage/DailyReportPage";
import {ProductReceiveDailyReportPage} from "../pages/ProductReceiveDailyReportPage/ProductReceiveDailyReportPage";
import {ProductInWarehousesReportPage} from "../pages/ProductInWarehousesReportPage/ProductInWarehousesReportPage";
import {WarehouseOverviewByProductsReportPage} from "../pages/WarehouseOverviewByProductsReportPage/WarehouseOverviewByProductsReportPage";
import {WarehouseDetailsByProductReportPage} from "../pages/WarehouseDetailsByProductReportPage/WarehouseDetailsByProductReportPage";
import {ProductQuantityByDayReportPage} from "../pages/ProductQuantityByDayReportPage/ProductQuantityByDayReportPage";
import {RepromaterialOverviewReportPage} from "../pages/RepromaterialOverviewReportPage/RepromaterialOverviewReportPage";
import {RepromaterialByPartnersReportPage} from "../pages/RepromaterialByPartnersReportPage/RepromaterialByPartnersReportPage";
import {AnnouncedVehiclesReportPage} from "../pages/AnnouncedVehiclesReportPage/AnnouncedVehiclesReportPage";
import {RequestWithUnfinishedDispositionsPage} from "../pages/RequestWithUnfinishedDispositionsPage/RequestWithUnfinishedDispositionsPage";
import {NotAllowedPage} from "../pages/NotAllowedPage/NotAllowedPage";
import {DispositionsMapPageNew} from "../pages/DispositionsMapPageNew/DispositionsMapPageNew";
import {DispositionsByRequestPageNew} from "../pages/DispositionsByRequestPageNew/DispositionsByRequestPageNew";
import {OwnershipDocumentPage} from "../pages/OwnershipDocumentPage/OwnershipDocumentPage";
import {OwnershipDocumentsPage} from "../pages/OwnershipDocumentsPage/OwnershipDocumentsPage";
import {OwnershipReproDocumentPage} from "../pages/OwnershipReproDocumentPage/OwnershipReproDocumentPage";
import {OwnershipReproDocumentsPage} from "../pages/OwnershipReproDocumentsPage/OwnershipReproDocumentsPage";
import {VirtualWarehousePage} from "../pages/VirtualWarehousePage/VirtualWarehousePage";
import {ForeignProductsPage} from "../pages/ForeignProductsPage/ForeignProductPage";
import {ForeignReproProductsPage} from "../pages/ForeignReproProductsPage/ForeignReproProductPage";
import {ServicedMeasurementPage} from "../pages/ServicedMeasurementPage/ServicedMeasurementPage";
import {ServicedMeasurementsPage} from "../pages/ServicedMeasurementsPage/ServicedMeasurementsPage";
import { ProcessingRequestsPage } from "../pages/ProcessingRequestsPage/ProcessingRequestsPage";
import { ProcessingRequestDetailsPage } from "../pages/ProcessingRequestsDetailsPage/ProcessingRequestsDetailsPage";
import { ProcessingProductInputsPage } from "../pages/ProcessingProductInputsPage/ProcessingProductInputsPage";
import { ProcessingOrdersPage } from "../pages/ProcessingOrdersPage/ProcessingOrdersPage";
import { ProcessingOrderOverviewPage } from "../pages/ProcessingOrderOverviewPage/ProcessingOrderOverviewPage";
import { ProcessingLogsPage } from "../pages/ProcessingLogsPage/ProcessingLogsPage";
import { ProcessingLogOverviewPage } from "../pages/ProcessingLogOverviewPage/ProcessingLogOverviewPage";
import { DeclarationsPage } from "../pages/DeclarationsPage/DeclarationsPage";
import { DeclarationOverviewPage } from "../pages/DeclarationOverviewPage/DeclarationOverviewPage";
import { NaturalProductsAmountReportPage } from "../pages/NaturalProductsAmountReportPage/NaturalProductsAmountReportPage";
import { NaturalReproAmountReportPage } from "../pages/NaturalReproAmountReportPage/NaturalReproAmountReportPage";
import { InventoryCountListPage } from "../pages/InventoryCountListPage/InventoryCountListPage";
import { InitialStateFromExcelPage } from "../pages/InitialStateFromExcelPage/InitialStateFromExcelPage";
import { AuditLogPage } from "../pages/AuditLogPage/AuditLogPage";

export interface AppRoutesProps {
};

export const AppRoutes = (p: AppRoutesProps) => {

  const navigate = useNavigate();
  const { t } = useTranslation(); 
  const {state, setMainMenu} = useApplicationContext()

  useEffect(() => {
    // Ponovo postavi meni kada se promeni jezik
    setMainMenu(mainMenuDefinitionSuperAdmin);
  }, [t]); 

  const isProcessingWarehouseman =
    activeUser?.role?.name === RoleType.Warehouseman &&
    activeUser?.warehouse?.finishingCenter === true;

  const mainMenuDefinitionSuperAdmin = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
        {
          label: t("Nerealizovane dispozicije"),
          command: () => navigate("/request-with-unfinished-dispositions"),
        },
      ],
    },
    {
      label: t("Dispozicije"),
      icon: "bi bi-truck",
      items: [
        { label: t("Pregled svih"), command: () => navigate("/dispositions-map-fast") },
        { label: t("Pregled po zahtevima"), command: () => navigate("/dispositions-by-request-fast") },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Korisnici"),
      icon: "bi bi-people",
      command: () => navigate("/users"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        { label: t("Spisak magacina"), command: () => navigate("/warehouses") },
        {
          label: t("Početno stanje merkantile"),
          command: () => navigate("/initial-warehouse-mercantile-state"),
        },
        {
          label: t("Početno stanje repromaterijala"),
          command: () => navigate("/initial-warehouse-repromaterial-state"),
        },
        {
          label: t("Virtuelni magacin"),
          command: () => navigate("/virtual-warehouse")
        },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Popisne liste"),
          command: () => navigate("/inventory-count-list"),
        },
        {
          label: t("Početno stanje iz excel-a"),
          command: () => navigate("/initial-state-from-excel-page"),
        },
        {
          label: t("Uslužno merenje"),
          command: () => navigate("/serviced-measurement"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        { label: t("Spisak robe"), command: () => navigate("/products") },
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
        {
          label: t("Rezervacije merkantile"),
          command: () => navigate("/product-reservation"),
        },
        {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
        {
          label: t("Vlasnički listovi merk."),
          command: () => navigate("/ownership-documents"),
        },
        {
          label: t("Vlasnički listovi repr."),
          command: () => navigate("/ownership-repro-documents"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Magacini po danima"),
          command: () => navigate("/daily-report"),
        },
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
        {
          label: t("Analiza magacina"),
          command: () => navigate("/warehouse-details-by-product-report"),
        },
        {
          label: t("Roba po magacinima"),
          command: () => navigate("/product-in-warehouses-report"),
        },
        {
          label: t("Roba po dobavljačima"),
          command: () => navigate("/product-receive-daily-report"),
        },
        {
          label: t("Stanje robe dan"),
          command: () => navigate("/product-quantity-by-days-report"),
        },
        {
          label: t("Repromaterijal na lageru"),
          command: () => navigate("/repromaterial-overview-report"),
        },
        {
          label: t("Tudja m. roba na lageru"),
          command: () => navigate("/foreign-products"),
        },
        {
          label: t("Tudja r. roba na lageru"),
          command: () => navigate("/foreign-repro-products"),
        },
        {
          label: t("Isporučena roba kupcu"),
          command: () => navigate("/repromaterial-by-partners-report"),
        },
        {
          label: t("Najavljena vozila"),
          command: () => navigate("/announced-vehicles-report"),
        },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
    {
      label: t("Podešavanja"),
      icon: "bi bi-gear",
      command: () => navigate("/settings"),
    },
    {
      label: t("Istorija"),
      icon: "bi bi-journal-text",
      command: () => navigate("/audit-log"),
    },
  ];

  const mainMenuDefinitionAdmin = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
        {
          label: t("Nerealizovane dispozicije"),
          command: () => navigate("/request-with-unfinished-dispositions"),
        },
      ],
    },
    {
      label: t("Dispozicije"),
      icon: "bi bi-truck",
      items: [
        { label: t("Pregled svih"), command: () => navigate("/dispositions-map-fast") },
        { label: t("Pregled po zahtevima"), command: () => navigate("/dispositions-by-request-fast") },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Korisnici"),
      icon: "bi bi-people",
      command: () => navigate("/users"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        {
          label: t("Spisak magacina"),
          command: () => navigate("/warehouses")
        },
        {
          label: t("Virtuelni magacin"),
          command: () => navigate("/virtual-warehouse")
        },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Popisne liste"),
          command: () => navigate("/inventory-count-list"),
        },
        {
          label: t("Početno stanje iz excel-a"),
          command: () => navigate("/initial-state-from-excel-page"),
        },
        {
          label: t("Uslužno merenje"),
          command: () => navigate("/serviced-measurement"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        {
          label: t("Spisak robe"),
          command: () => navigate("/products")
        },
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
        {
          label: t("Rezervacije merkantile"),
          command: () => navigate("/product-reservation"),
        },
        {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
        {
          label: t("Vlasnički listovi merk."),
          command: () => navigate("/ownership-documents"),
        },
        {
          label: t("Vlasnički listovi repr."),
          command: () => navigate("/ownership-repro-documents"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Magacini po danima"),
          command: () => navigate("/daily-report"),
        },
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
        {
          label: t("Analiza magacina"),
          command: () => navigate("/warehouse-details-by-product-report"),
        },
        {
          label: t("Roba po magacinima"),
          command: () => navigate("/product-in-warehouses-report"),
        },
        {
          label: t("Roba po dobavljačima"),
          command: () => navigate("/product-receive-daily-report"),
        },
        {
          label: t("Stanje robe dan"),
          command: () => navigate("/product-quantity-by-days-report"),
        },
        {
          label: t("Repromaterijal na lageru"),
          command: () => navigate("/repromaterial-overview-report"),
        },
        {
          label: t("Tudja m. roba na lageru"),
          command: () => navigate("/foreign-products"),
        },
        {
          label: t("Tudja r. roba na lageru"),
          command: () => navigate("/foreign-repro-products"),
        },
        {
          label: t("Isporučena roba kupcu"),
          command: () => navigate("/repromaterial-by-partners-report"),
        },
        {
          label: t("Najavljena vozila"),
          command: () => navigate("/announced-vehicles-report"),
        },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
    {
      label: t("Podešavanja"),
      icon: "bi bi-gear",
      command: () => navigate("/settings"),
    },
  ];

  const mainMenuDefinitionDirector = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
        {
          label: t("Nerealizovane dispozicije"),
          command: () => navigate("/request-with-unfinished-dispositions"),
        },
      ],
    },
    {
      label: t("Dispozicije"),
      icon: "bi bi-truck",
      items: [
        { label: t("Pregled svih"), command: () => navigate("/dispositions-map-fast") },
        { label: t("Pregled po zahtevima"), command: () => navigate("/dispositions-by-request-fast") },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Korisnici"),
      icon: "bi bi-people",
      command: () => navigate("/users"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        {
          label: t("Spisak magacina"),
          command: () => navigate("/warehouses")
        },
        {
          label: t("Virtuelni magacin"),
          command: () => navigate("/virtual-warehouse")
        },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Popisne liste"),
          command: () => navigate("/inventory-count-list"),
        },
        {
          label: t("Početno stanje iz excel-a"),
          command: () => navigate("/initial-state-from-excel-page"),
        },
        {
          label: t("Uslužno merenje"),
          command: () => navigate("/serviced-measurement"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        { label: t("Spisak robe"), command: () => navigate("/products") },
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
        {
          label: t("Rezervacije merkantile"),
          command: () => navigate("/product-reservation"),
        },
        {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
        {
          label: t("Vlasnički merk."),
          command: () => navigate("/ownership-documents"),
        },
        {
          label: t("Vlasnički listovi repr."),
          command: () => navigate("/ownership-repro-documents"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Magacini po danima"),
          command: () => navigate("/daily-report"),
        },
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
        {
          label: t("Analiza magacina"),
          command: () => navigate("/warehouse-details-by-product-report"),
        },
        {
          label: t("Roba po magacinima"),
          command: () => navigate("/product-in-warehouses-report"),
        },
        {
          label: t("Roba po dobavljačima"),
          command: () => navigate("/product-receive-daily-report"),
        },
        {
          label: t("Stanje robe dan"),
          command: () => navigate("/product-quantity-by-days-report"),
        },
        {
          label: t("Repromaterijal na lageru"),
          command: () => navigate("/repromaterial-overview-report"),
        },
        {
          label: t("Tudja m. roba na lageru"),
          command: () => navigate("/foreign-products"),
        },
        {
          label: t("Tudja r. roba na lageru"),
          command: () => navigate("/foreign-repro-products"),
        },
        {
          label: t("Isporučena roba kupcu"),
          command: () => navigate("/repromaterial-by-partners-report"),
        },
        {
          label: t("Najavljena vozila"),
          command: () => navigate("/announced-vehicles-report"),
        },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
    {
      label: t("Podešavanja"),
      icon: "bi bi-gear",
      command: () => navigate("/settings"),
    },
  ];

  const mainMenuDefinitionLogistician = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
        {
          label: t("Nerealizovane dispozicije"),
          command: () => navigate("/request-with-unfinished-dispositions"),
        },
      ],
    },
    {
      label: t("Dispozicije"),
      icon: "bi bi-truck",
      items: [
        { label: t("Pregled svih"), command: () => navigate("/dispositions-map-fast") },
        { label: t("Pregled po zahtevima"), command: () => navigate("/dispositions-by-request-fast") },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        { label: t("Spisak magacina"), command: () => navigate("/warehouses") },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Virtuelni magacin"),
          command: () => navigate("/virtual-warehouse")
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        { label: t("Spisak robe"), command: () => navigate("/products") },
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
        {
          label: t("Rezervacije merkantile"),
          command: () => navigate("/product-reservation"),
        },
        {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Magacini po danima"),
          command: () => navigate("/daily-report"),
        },
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
        {
          label: t("Analiza magacina"),
          command: () => navigate("/warehouse-details-by-product-report"),
        },
        {
          label: t("Roba po magacinima"),
          command: () => navigate("/product-in-warehouses-report"),
        },
        {
          label: t("Roba po dobavljačima"),
          command: () => navigate("/product-receive-daily-report"),
        },
        {
          label: t("Stanje robe dan"),
          command: () => navigate("/product-quantity-by-days-report"),
        },
        {
          label: t("Repromaterijal na lageru"),
          command: () => navigate("/repromaterial-overview-report"),
        },
        {
          label: t("Tudja m. roba na lageru"),
          command: () => navigate("/foreign-products"),
        },
        {
          label: t("Tudja r. roba na lageru"),
          command: () => navigate("/foreign-repro-products"),
        },
        {
          label: t("Isporučena roba kupcu"),
          command: () => navigate("/repromaterial-by-partners-report"),
        },
        {
          label: t("Najavljena vozila"),
          command: () => navigate("/announced-vehicles-report"),
        },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
    {
      label: t("Podešavanja"),
      icon: "bi bi-gear",
      command: () => navigate("/settings"),
    },
  ];

  const mainMenuDefinitionCommercialist = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
        {
          label: t("Dispozicije po zahtevima"),
          command: () => navigate("/dispositions-by-request-fast")
        },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
        {
          label: t("Rezervacije merkantile"),
          command: () => navigate("/product-reservation"),
        },
        {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
      ],
    },
  ];

  const mainMenuDefinitionBackOffice = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        {
          label: t("Virtuelni magacin"),
          command: () => navigate("/virtual-warehouse")
        },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Uslužno merenje"),
          command: () => navigate("/serviced-measurement"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        { label: t("Spisak robe"), command: () => navigate("/products") },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
  ];

  const mainMenuDefinitionWarehouseman = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: (event: any) => navigate("/repromaterial-input-fast")
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast")
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Uslužno merenje"),
          command: () => navigate("/serviced-measurement"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Roba po magacinima"),
          command: () => navigate("/product-in-warehouses-report"),
        },
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
      ],
    },
  ];

  const mainMenuDefinitionControlHouse = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
  ];

   const mainMenuDefinitionFinishedCenter = [
    {
      label: t("Dashboard"),
      icon: "bi bi-house",
      command: () => navigate("/dashboard"),
    },
    {
      label: t("Zahtevi"),
      icon: "bi bi-chat-left-text",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repro-requests-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-requests-fast"),
        },
      ],
    },
    {
      label: t("Ulaz robe"),
      icon: "bi bi-save",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-input-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-input-fast"),
        },
      ],
    },
    {
      label: t("Izlaz robe"),
      icon: "bi bi-box-arrow-up",
      items: [
        {
          label: t("Repromaterijal"),
          command: () => navigate("/repromaterial-output-fast"),
        },
        {
          label: t("Merkantila"),
          command: () => navigate("/mercantile-output-fast"),
        },
      ],
    },
    {
      label: t("Partneri"),
      icon: "bi bi-person-lines-fill",
      command: () => navigate("/partners"),
    },
    {
      label: t("Magacini"),
      icon: "bi bi-shop-window",
      items: [
        { label: t("Spisak magacina"), command: () => navigate("/warehouses") },
        {
          label: t("Stanje magacina"),
          command: () => navigate("/warehouses-overview"),
        },
        {
          label: t("Početno stanje repromaterijala"),
          command: () => navigate("/initial-warehouse-repromaterial-state"),
        },
      ],
    },
    {
      label: t("Roba"),
      icon: "bi bi-box-seam",
      items: [
        { label: t("Spisak robe"), command: () => navigate("/products") },
        {
          label: t("Stanje robe"),
          command: () => navigate("/product-overview"),
        },
         {
          label: t("Rezervacije repromaterijala"),
          command: () => navigate("/product-repro-reservation"),
        },
        {
          label: t("Vlasnički listovi merk."),
          command: () => navigate("/ownership-documents"),
        },
        {
          label: t("Vlasnički listovi repr."),
          command: () => navigate("/ownership-repro-documents"),
        },
      ],
    },
    {
      label: t("Izveštaji"),
      icon: "bi bi-file-text",
      items: [
        {
          label: t("Kartica magacina"),
          command: () => navigate("/warehouse-overview-by-products-report"),
        },
        {
          label: t("Isporučena roba kupcu"),
          command: () => navigate("/repromaterial-by-partners-report"),
        },
        {
          label: t("Stanje robe dan"),
          command: () => navigate("/product-quantity-by-days-report"),
        },
        {
          label: t("Repromaterijal na lageru"),
          command: () => navigate("/repromaterial-overview-report"),
        },
        {
          label: t("Tudja m. roba na lageru"),
          command: () => navigate("/foreign-products"),
        },
        {
          label: t("Tudja r. roba na lageru"),
          command: () => navigate("/foreign-repro-products"),
        },
      ],
    },
    {
      label: t("Doradni centar"),
      icon: "bi bi-boxes",
      items: [
        {
          label: t("Prijemni zahtevi"),
          command: () => navigate("/processing-requests"),
        },
        {
          label: t("Prijemnice"),
          command: () => navigate("/processing-product-inputs"),
        },
        {
          label: t("Nalozi za doradu"),
          command: () => navigate("/processing-orders"),
        },
        {
          label: t("Zapisnici o doradi"),
          command: () => navigate("/processing-logs"),
        },
        {
          label: t("Deklaracije"),
          command: () => navigate("/declarations"),
        },
        {
          label: t("Stanje naturalne robe"),
          command: () => navigate("/natural-stock"),
        },
        {
          label: t("Stanje zalihe semena"),
          command: () => navigate("/natural-repro-amount"),
        },
      ],
    },
  ];

  const onMenuItemClick = (path: string) => {
    navigate(path)
  }

  useEffect(() => {
    let mainMenuDefinition: any = [];

    if (activeUser) {
      switch (activeUser.role?.name) {
        case RoleType.Administrator:
          mainMenuDefinition = mainMenuDefinitionAdmin;
          break;
        case RoleType.Superadmin:
          mainMenuDefinition = mainMenuDefinitionSuperAdmin;
          break;
        case RoleType.Logistician:
          mainMenuDefinition = mainMenuDefinitionLogistician;
          break;
        case RoleType.Warehouseman:
          mainMenuDefinition = isProcessingWarehouseman
            ? [
              ...mainMenuDefinitionWarehouseman,
              {
                label: t("Doradni centar"),
                icon: "bi bi-boxes",
                items: [
                  {
                    label: t("Prijemnice"),
                    command: () => navigate("/processing-product-inputs"),
                  },
                ],
              },
            ]
          : mainMenuDefinitionWarehouseman;
          break;
        case RoleType.Commercialist:
          mainMenuDefinition = mainMenuDefinitionCommercialist;
          break;
        case RoleType.CommercialistII:
          mainMenuDefinition = mainMenuDefinitionCommercialist;
          break;
        case RoleType.Backoffice:
          mainMenuDefinition = mainMenuDefinitionBackOffice;
          break;
        case RoleType.Director:
          mainMenuDefinition = mainMenuDefinitionDirector;
          break;
        case RoleType.ControlHouse:
          mainMenuDefinition = mainMenuDefinitionControlHouse;
          break;
        case RoleType.FinishingCenter:
          mainMenuDefinition = mainMenuDefinitionFinishedCenter;
        break;
      }
    } else {
      mainMenuDefinition = [];
    }
    // mainMenuDefinition = addUidsToMenuItems(mainMenuDefinition)
    setMainMenu(mainMenuDefinition)
  }, [activeUser])

  return (
        <Routes>
            <Route path="/" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><DashboardPage /></ProtectedElement>} />
            <Route path="dashboard" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><DashboardPage /></ProtectedElement>} />
            <Route path="login" element={<LoginPage />} />
            <Route path="partners" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Backoffice, RoleType.Logistician, RoleType.FinishingCenter]} ><PartnersPage /></ProtectedElement>} />
            <Route path="warehouses" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><WarehousesPage /></ProtectedElement>} />
            <Route path="initial-warehouse-mercantile-state" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Director]}><InitialWarehouseStatePage /></ProtectedElement>} />
            <Route path="initial-warehouse-repromaterial-state" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Director, RoleType.FinishingCenter]}><InitialWarehouseRepromaterialStatePage /></ProtectedElement>} />
            <Route path="warehouses-overview" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.Warehouseman, RoleType.FinishingCenter]}><WarehousesOverviewPage /></ProtectedElement>} />
            <Route path="products" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><ProductsPage /></ProtectedElement>} />
            <Route path="mercantile-requests-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Commercialist, RoleType.CommercialistII, RoleType.Backoffice, RoleType.FinishingCenter]}><NewMercantileRequestsPage /></ProtectedElement>} />
            <Route path="mercantile-request-details-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><NewMercantileRequestDetailsPage /></ProtectedElement>} />
            <Route path="repro-requests-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Commercialist, RoleType.CommercialistII, RoleType.Backoffice, RoleType.FinishingCenter]}><NewReproRequestsPage /></ProtectedElement>} />
            <Route path="repro-request-details-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><NewReproRequestDetailsPage /></ProtectedElement>} />
            <Route path="users" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director]}><UsersPage /></ProtectedElement>} />
            <Route path="settings" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director]}><SettingsPage /></ProtectedElement>} />
            <Route path="product-reservation" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Commercialist, RoleType.CommercialistII]}><ProductReservationPage /></ProtectedElement>} />
            <Route path="product-repro-reservation" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><ProductReproReservationPage /></ProtectedElement>} />
            <Route path="product-overview" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><ProductOverviewPage /></ProtectedElement>} />
            <Route path="document-of-receive-fast/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfReceivePage /></ProtectedElement>}/>
            <Route path="document-of-receive-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfReceivePage /></ProtectedElement>} />
            <Route path="document-of-receive-preview-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin,RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewDocumentOfReceivePreviewPage /></ProtectedElement>} />
            <Route path="document-of-output-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfOutputPage /></ProtectedElement>} />
            <Route path="document-of-output-preview-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewDocumentOfOutputPreviewPage /></ProtectedElement>} />
            <Route path="document-of-receive-repromaterial-fast/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfReceiveRepromaterialPage /></ProtectedElement>} />
            <Route path="document-of-receive-repromaterial-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfReceiveRepromaterialPage /></ProtectedElement>} />
            <Route path="document-of-receive-repromaterial-preview-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewDocumentOfReceiveRepromaterialPreviewPage /></ProtectedElement>} />
            <Route path="document-of-output-repromaterial-fast/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfOutputRepromaterialPage /></ProtectedElement>} />
            <Route path="document-of-output-repromaterial-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Director, RoleType.FinishingCenter]}><NewDocumentOfOutputRepromaterialPage /></ProtectedElement>} />
            <Route path="document-of-output-repromaterial-preview-fast/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewDocumentOfOutputRepromaterialPreviewPage /></ProtectedElement>} />
            <Route path="repromaterial-input-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewRepromaterialInputPage /></ProtectedElement>} />
            <Route path="mercantile-input-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewMercantileInputPage /></ProtectedElement>} />
            <Route path="repromaterial-output-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewRepromaterialOutputPage /></ProtectedElement>} />
            <Route path="mercantile-output-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.ControlHouse, RoleType.Commercialist, RoleType.CommercialistII, RoleType.FinishingCenter]}><NewMercantileOutputPage /></ProtectedElement>} />
            <Route path="daily-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><DailyReportPage /></ProtectedElement>} />
            <Route path="product-receive-daily-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><ProductReceiveDailyReportPage /></ProtectedElement>} />
            <Route path="product-in-warehouses-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><ProductInWarehousesReportPage /></ProtectedElement>} />
            <Route path="warehouse-overview-by-products-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><WarehouseOverviewByProductsReportPage /></ProtectedElement>} />
            <Route path="repromaterial-overview-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><RepromaterialOverviewReportPage /></ProtectedElement>} />
            <Route path="warehouse-details-by-product-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><WarehouseDetailsByProductReportPage /></ProtectedElement>} />
            <Route path="repromaterial-by-partners-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><RepromaterialByPartnersReportPage /></ProtectedElement>} />
            <Route path="product-quantity-by-days-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><ProductQuantityByDayReportPage /></ProtectedElement>} />
            <Route path="request-with-unfinished-dispositions" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director]}><RequestWithUnfinishedDispositionsPage /></ProtectedElement>} />
            <Route path="announced-vehicles-report" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Warehouseman, RoleType.Logistician, RoleType.Director]}><AnnouncedVehiclesReportPage /></ProtectedElement>} />
            <Route path="dispositions-map-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Logistician]}><DispositionsMapPageNew /></ProtectedElement>} />
            <Route path="dispositions-by-request-fast" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Logistician, RoleType.Commercialist, RoleType.CommercialistII]}><DispositionsByRequestPageNew /></ProtectedElement>} />
            <Route path="ownership-document/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter]}><OwnershipDocumentPage /></ProtectedElement>} />
            <Route path="ownership-documents" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter]}><OwnershipDocumentsPage /></ProtectedElement>} />
            <Route path="ownership-repro-document/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter]}><OwnershipReproDocumentPage /></ProtectedElement>} />
            <Route path="ownership-repro-documents" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter]}><OwnershipReproDocumentsPage /></ProtectedElement>} />
            <Route path="virtual-warehouse" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Backoffice, RoleType.Logistician]}><VirtualWarehousePage /></ProtectedElement>} />
            <Route path="foreign-products" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><ForeignProductsPage /></ProtectedElement>} />
            <Route path="foreign-repro-products" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.FinishingCenter]}><ForeignReproProductsPage /></ProtectedElement>} />
            <Route path="serviced-measurement/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Warehouseman, RoleType.Backoffice]}><ServicedMeasurementPage /></ProtectedElement>} />
            <Route path="serviced-measurement" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.Warehouseman, RoleType.Backoffice]}><ServicedMeasurementsPage /></ProtectedElement>} />
            <Route path="processing-requests" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter, RoleType.Backoffice, RoleType.Logistician]}><ProcessingRequestsPage /></ProtectedElement>} />
            <Route path="processing-requests-details/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director, RoleType.FinishingCenter, RoleType.Backoffice, RoleType.Logistician]}><ProcessingRequestDetailsPage /></ProtectedElement>} />
            <Route
              path="processing-product-inputs"
              element={
                isProcessingWarehouseman ? (
                  <ProcessingProductInputsPage />
                ) : (
                  <ProtectedElement
                    allowedTo={[
                      RoleType.Superadmin,
                      RoleType.Administrator,
                      RoleType.Director,
                      RoleType.FinishingCenter,
                      RoleType.Backoffice,
                      RoleType.Logistician,
                    ]}
                  >
                    <ProcessingProductInputsPage />
                  </ProtectedElement>
                )
              }
            />
            <Route path="processing-orders" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><ProcessingOrdersPage /></ProtectedElement>} />
            <Route path="processing-orders/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><ProcessingOrderOverviewPage /></ProtectedElement>} />
            <Route path="processing-orders/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><ProcessingOrderOverviewPage /></ProtectedElement>} />
            <Route path="processing-logs" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><ProcessingLogsPage /></ProtectedElement>} />
            <Route path="processing-logs/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><ProcessingLogOverviewPage /></ProtectedElement>} />
            <Route path="processing-logs/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><ProcessingLogOverviewPage /></ProtectedElement>} />
            <Route path="declarations" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><DeclarationsPage /></ProtectedElement>} />
            <Route path="declarations/new" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><DeclarationOverviewPage /></ProtectedElement>} />
            <Route path="declarations/:id" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Backoffice, RoleType.Director, RoleType.FinishingCenter]}><DeclarationOverviewPage /></ProtectedElement>} />
            <Route path="natural-stock" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><NaturalProductsAmountReportPage /></ProtectedElement>} />
            <Route path="natural-repro-amount" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Logistician, RoleType.Director, RoleType.Backoffice, RoleType.FinishingCenter]}><NaturalReproAmountReportPage /></ProtectedElement>} />
            <Route path="inventory-count-list" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director]}><InventoryCountListPage /></ProtectedElement>} />
            <Route path="initial-state-from-excel-page" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Administrator, RoleType.Director]}><InitialStateFromExcelPage /></ProtectedElement>} />
            <Route path="audit-log" element={<ProtectedElement allowedTo={[RoleType.Superadmin, RoleType.Director]}><AuditLogPage /></ProtectedElement>} />
            <Route path="/not-allowed" element={<NotAllowedPage />} />
            <Route path="*" element={<div>nothing here</div>} />
        </Routes>
    );
};
